import { render, staticRenderFns } from "./scrollComponent.vue?vue&type=template&id=4a9c84c9&scoped=true"
import script from "./scrollComponent.vue?vue&type=script&lang=js"
export * from "./scrollComponent.vue?vue&type=script&lang=js"
import style0 from "./scrollComponent.vue?vue&type=style&index=0&id=4a9c84c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c84c9",
  null
  
)

export default component.exports